import { AppButton, AppMultiInputText, AppTextArea } from 'components';
import BoardsList from 'components/BoardsList';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import YearsList from 'components/YearsList';
import useManageQuizSettings from 'hooks/API/useManageQuizSettings';
import { memo, useEffect, useState } from 'react';
import { keyMapper } from '.';

function QuizSettings({ open, closeModal, data = {}, canSave = false }) {
  const { quizId, preFilledSettings = null } = data;

  const { isLoading, mutate } = useManageQuizSettings({ quizId });

  const [guidelines, setGuidelines] = useState('');
  const [papers, setPapers] = useState([]);
  const [sections, setSections] = useState([]);
  const [examBoard, setExamBoard] = useState();
  const [askedInYear, setAskedInYear] = useState();

  const showBoardAndYear = data?.activeTab === keyMapper.previous_year && data?.isPerform;

  useEffect(() => {
    if (preFilledSettings) {
      const { guidelines, papers, sections, askedInYear, examBoard } = preFilledSettings || {};
      setExamBoard(examBoard);
      setAskedInYear(askedInYear);
      setGuidelines(guidelines);
      setPapers(papers?.map?.((p) => ({ ...p, label: p.value })));
      setSections(sections?.map?.((p) => ({ ...p, label: p.value })));
    }
  }, [preFilledSettings]);

  function handleSave() {
    if (isLoading) return;

    const apiData = {
      guidelines,
      papers,
      sections,
    };

    if (showBoardAndYear && examBoard) apiData.examBoard = examBoard;
    if (showBoardAndYear && askedInYear) apiData.askedInYear = askedInYear;

    mutate(apiData, {
      onSuccess() {
        closeModal();
      },
    });
  }

  return (
    <AppModal open={open} closeModal={closeModal} size="md">
      <AppModalHeader>Settings</AppModalHeader>
      <AppModalBody classNames="p-4">
        <div className="row">
          <div className="col-12 my-4">
            <AppTextArea
              areaProps={{
                value: guidelines,
                onChange: (event) => setGuidelines(event.target.value),
                placeholder: 'Guidelines',
                rows: 10,
              }}
              label="Guidelines"
            />
          </div>
          {data?.activeTab !== keyMapper.past_papers && (
            <div className="col-12 my-4">
              <AppMultiInputText
                heading={'Papers'}
                value={papers}
                setValue={(data) => setPapers(data)}
              />
            </div>
          )}
          {data?.activeTab !== keyMapper.past_papers && (
            <div className="col-12 my-4">
              <AppMultiInputText
                heading={'Sections'}
                value={sections}
                setValue={(data) => setSections(data)}
              />
            </div>
          )}
        </div>

        {showBoardAndYear && (
          <>
            <div className="row">
              <div className="col-6">
                <BoardsList
                  value={examBoard}
                  handleChange={({ examBoard }) => setExamBoard(examBoard)}
                />
              </div>
              <div className="col-6">
                <YearsList
                  value={askedInYear}
                  handleChange={({ askedInYear }) => setAskedInYear(askedInYear)}
                />
              </div>
            </div>
          </>
        )}
        <div className="d-flex flex-row mt-4 justify-content-center">
          {canSave && (
            <>
              <AppButton
                type="button"
                variantClass="btn-primary mx-3"
                style={{ minWidth: '1.5rem' }}
                onClick={handleSave}
              >
                {isLoading ? 'Saving...' : 'Save'}
              </AppButton>
            </>
          )}
        </div>
      </AppModalBody>
    </AppModal>
  );
}

export default memo(QuizSettings);
